import { render, staticRenderFns } from "./QuoteRemoveDialog.vue?vue&type=template&id=1189f119&scoped=true"
import script from "./QuoteRemoveDialog.vue?vue&type=script&lang=ts"
export * from "./QuoteRemoveDialog.vue?vue&type=script&lang=ts"
import style0 from "./QuoteRemoveDialog.vue?vue&type=style&index=0&id=1189f119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1189f119",
  null
  
)

export default component.exports